export default __webpack_public_path__ + "static/media/green_large.6f03376a.png";